import { __assign, __rest } from "tslib";
import React from "react";
import Svg from "./Svg";
var SvgSubtract = function (_a) {
    var _b = _a.size, size = _b === void 0 ? 24 : _b, props = __rest(_a, ["size"]);
    return (React.createElement(Svg, __assign({ fill: "currentColor", viewBox: "0 0 24 24", size: size }, props),
        React.createElement("g", { clipPath: "url(#subtract_svg__clip0)" },
            React.createElement("path", { fill: "currentColor", d: "M9.143 10H2.857C1.28 10 0 11.106 0 12.47c0 1.365 1.28 2.471 2.857 2.471h18.286c1.578 0 2.857-1.106 2.857-2.47C24 11.106 22.72 10 21.143 10h-12z" })),
        React.createElement("defs", null,
            React.createElement("clipPath", { id: "subtract_svg__clip0" },
                React.createElement("path", { fill: "currentColor", d: "M0 0h24v24H0z" })))));
};
export default SvgSubtract;
//# sourceMappingURL=Subtract.js.map